export default "/static/images/build_middle_1.png?a67042c92da5d19af38dbe85f058c8e3";